import React, { useState } from 'react';
import OtpInput from './OtpInput';
import { formatKoreanPhone } from '../utils/phone';
import useBackButtonClose from '../utils/useBackButtonClose';

const OTP_API = process.env.REACT_APP_OTP_API_URL
  || 'https://qdtjpudqk3.execute-api.ap-northeast-2.amazonaws.com/prod';

export default function PhoneVerificationModal({ open, sub, provider, name, email, onSuccess, onCancel }) {
  const [phone, setPhone] = useState('');
  const [otpToken, setOtpToken] = useState('');
  const [linking, setLinking] = useState(false);
  const [error, setError] = useState('');

  const handleOtpVerified = (token) => setOtpToken(token);

  const handleLink = async () => {
    setLinking(true); setError('');
    try {
      const res = await fetch(`${OTP_API}/profiles/link`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sub, provider, name, email, otpToken }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || '연결 실패');
      } else {
        onSuccess(data);
      }
    } catch {
      setError('네트워크 오류');
    }
    setLinking(false);
  };

  // 모바일 뒤로가기로 인증 취소 후 로그인 화면 복귀(SPA 이탈 방지).
  useBackButtonClose(open, () => onCancel?.());

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.65)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div style={{
        background: 'var(--surface)', borderRadius: 'var(--radius)',
        border: '1px solid var(--border)',
        padding: 28, maxWidth: 420, width: '100%',
        boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
      }}>
        <h3 style={{ margin: '0 0 10px' }}>전화번호 인증이 필요합니다</h3>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: 20 }}>
          로그인 보호 및 서비스 안내를 위해 전화번호를 확인합니다. 최초 1회만 수행합니다.
        </p>

        <label style={{ display: 'block', marginBottom: 6, fontSize: '0.85rem' }}>전화번호</label>
        <input
          type="tel"
          placeholder="010-1234-5678"
          value={phone}
          onChange={(e) => setPhone(formatKoreanPhone(e.target.value))}
          className="input"
          style={{ width: '100%', marginBottom: 8 }}
        />

        <OtpInput phoneNumber={phone} onVerified={handleOtpVerified} />

        {otpToken && (
          <button type="button" onClick={handleLink} disabled={linking}
            className="btn btn-primary"
            style={{ width: '100%', marginTop: 20, padding: '10px 0' }}>
            {linking ? '연결 중...' : '계정 연결 완료'}
          </button>
        )}
        {error && <div style={{ color: '#ff5252', fontSize: '0.85rem', marginTop: 10 }}>{error}</div>}
      </div>
    </div>
  );
}
